'use client'
import { useRef, useEffect } from 'react'

import { sendGTMEvent } from '@b-stock/fe-core/bstock-next/components'

import { GTM_PLATFORM } from './constants'

/**
 * Cookie name set by GTM when processing a `storefront_view` event.
 * GTM is responsible for writing this cookie (to respect consent mode).
 * This component only reads it to detect storefront changes.
 */
const GTM_STOREFRONT_COOKIE = '_gtm_storefront_id'

function getCookie(name: string): string | undefined {
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}=([^;]*)`)
  )
  return match?.[1] ? decodeURIComponent(match[1]) : undefined
}

export default function TrackStorefrontView({
  storefrontId,
  storefrontName,
}: {
  storefrontId?: string
  storefrontName?: string
}) {
  const hasTracked = useRef(false)

  useEffect(() => {
    if (hasTracked.current || !storefrontId) return

    const lastStorefrontId = getCookie(GTM_STOREFRONT_COOKIE)

    // Only fire when the storefront is different from the cookie value.
    // GTM is responsible for setting/updating the cookie on this event.
    if (lastStorefrontId === storefrontId) return

    sendGTMEvent({
      event: 'storefront_view',
      platform: GTM_PLATFORM,
      storefront_name: storefrontName,
    })

    hasTracked.current = true
  }, [storefrontId, storefrontName])

  return null
}
